import { render } from "./FooterCmp.vue?vue&type=template&id=525ff59a"
import script from "./FooterCmp.vue?vue&type=script&lang=js"
export * from "./FooterCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__